import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';

import { Theme } from '@constants';

import { RadialGradientBackgroundProps } from './types';

export const RadialGradientBackground: FC<RadialGradientBackgroundProps> = ({ children, style }) => (
  <View
    style={[
      styles.radialGradient,
      style,
      {
        backgroundImage: `radial-gradient(${Theme.gradients.loading.start}, ${Theme.gradients.loading.end})`,
      },
    ]}
  >
    {children}
  </View>
);

const styles = StyleSheet.create({
  radialGradient: {
    flex: 1,
  },
});
